<template>
  <section class="development-file">
    <v-login-info></v-login-info>

    <div class="content">
      <!--导航目录开始-->
      <nav class="nav">
        <span class="nav-home" @click="cdDirFn(0)">说明文档</span>
        <!--<span class="nav-item" v-for="item in navList" @click="cdDirFn(item.pid)">{{ item.text }}</span>-->
        <span class="nav-item" v-for="item in navList">/ {{ item.text }} /</span>
      </nav>
      <!--导航目录结束-->

      <div class="dir-box" v-for="(item, index) in listData">
        <div class="dir-style" v-if="item.type === 1" @click="cdDirFn(item.id)">
          <i class="icon-folder"></i>
          <span class="text">{{ item.text }}</span>
        </div>

        <div class="file-style" v-else @click="openFn(item.name, item.pid)">
          <i class="icon-file-pdf"></i>
          <span class="text">{{ item.text }}</span>
        </div>
      </div>

    </div>
  </section>
</template>

<script type="text/ecmascript-6">
  // 引入用户登录信息组件
  import loginInfo from 'components/loginInfo/loginInfo'
  export default {
    // 开发文档页面
    name: 'downloadPlugin',
    data () {
      return {
        // 列表数据
        listData: [],
        // 导航数据
        navList: [],
        // 目录数据
        dirTree: [
          {
            id: 1,
            pid: 0,
            name: '游戏本体说明',
            text: '游戏本体说明',
            type: 1,
            lev: 1,
            show: true
          },
          {
            id: 2,
            pid: 1,
            name: '总目录',
            text: '总目录.xlsx',
            type: 2,
            lev: 2,
            show: false
          },
          {
            id: 3,
            pid: 1,
            name: 'NEWART目录',
            text: 'NEWART目录.xlsx',
            type: 2,
            lev: 2,
            show: false
          },
          {
            id: 4,
            pid: 1,
            name: '_RESOURCES目录',
            text: '_RESOURCES目录.xlsx',
            type: 2,
            lev: 2,
            show: false
          },
          {
            id: 5,
            pid: 0,
            name: '开发工具说明',
            text: '开发工具说明',
            type: 1,
            lev: 1,
            show: true
          },
          {
            id: 6,
            pid: 5,
            name: '开发插件使用说明',
            text: '开发插件使用说明.docx',
            type: 3,
            lev: 2,
            show: false
          },
          {
            id: 7,
            pid: 0,
            name: '首先阅读',
            text: '首先阅读.docx',
            type: 3,
            lev: 1,
            show: true
          }
        ]
      }
    },
    created () {
      // 初始化目录数据
      this.listData = this.childFn(this.dirTree, this.$route.params.pid)
      // 初始化导航数据
      this.navList = this.parentFn(this.dirTree, this.$route.params.pid)
    },
    methods: {
      // 查找子分类
      childFn (arr, pid) {
        pid = parseInt(pid)
        // 初始化数组
        let list = []
        // 遍历数据
        arr.forEach((item) => {
          // 如果是子数据
          if (item.pid === pid) {
            // 添加到数据
            list.push(item)
          }
        })
        // 返回数据
        return list
      },
      // 查找父级分类
      parentFn (arr, id) {
        id = parseInt(id)
        let list = []
        arr.forEach((item) => {
          if (item.id === id) {
            list.push(item)
          }
        })
        return list
      },
      // 进入文件夹
      cdDirFn (id) {
        this.listData = this.childFn(this.dirTree, id)
        this.navList = this.parentFn(this.dirTree, id)
      },
      // 打开文件
      openFn (name, pid, id) {
        this.$router.push({path: `/pdf/${name}/${pid}`})
      }
    },
    components: {
      'v-login-info': loginInfo
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "developmentFile.styl";
</style>



// WEBPACK FOOTER //
// src/views/developmentFile/developmentFile.vue